// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.start-text-pXfZ2p{color:var(--light-usage-text-color-text-0,#1d1c23);font-size:14px;line-height:22px}.config-link-HEiJGW{color:var(--light-color-brand-brand-5,#4d53e8);font-size:12px;line-height:16px}.markdown-PFR8kZ{color:var(--light-usage-text-color-text-0,#1d1c23);font-size:14px;line-height:22px}.guide-XLqN5c{margin-bottom:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"start-text": `start-text-pXfZ2p`,
	"startText": `start-text-pXfZ2p`,
	"config-link": `config-link-HEiJGW`,
	"configLink": `config-link-HEiJGW`,
	"markdown": `markdown-PFR8kZ`,
	"guide": `guide-XLqN5c`
};
export default ___CSS_LOADER_EXPORT___;
